import { render, staticRenderFns } from "./ErDiagram.vue?vue&type=template&id=8def9e0e&scoped=true"
import script from "./ErDiagram.vue?vue&type=script&lang=js"
export * from "./ErDiagram.vue?vue&type=script&lang=js"
import style0 from "./ErDiagram.vue?vue&type=style&index=0&id=8def9e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8def9e0e",
  null
  
)

export default component.exports